<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatCount, hasValue } from '../helpers';

const props = defineProps({
  // [{ key, icon, value, label }]
  items: { type: Array, default: () => [] },
});

const { locale } = useI18n();

const visibleItems = computed(() =>
  props.items.filter(item => hasValue(item.value))
);
</script>

<template>
  <div v-if="visibleItems.length" class="flex flex-wrap items-center gap-1.5">
    <span
      v-for="item in visibleItems"
      :key="item.key"
      v-tooltip.top="item.label"
      class="inline-flex items-center gap-1 h-6 px-2 rounded-md bg-n-alpha-2 text-xs font-medium tabular-nums text-n-slate-12"
    >
      <span class="size-3.5 text-n-slate-10" :class="item.icon" />
      {{ formatCount(item.value, locale) }}
    </span>
  </div>
</template>
